<script>
import { Event } from '../../plugins/bus';
import { GarageLocationStore } from '../../stores/GarageLocationStore';

export default {
    computed: {
        querystring() {
            if (!this.params) {
                return '';
            }
            return (
                '?' +
                Object.keys(this.params)
                    .filter(key => !!this.params[key])
                    .map(key => key + '=' + this.params[key])
                    .join('&')
            );
        },
        params() {
            return {
                from: this.from || '',
                to: this.to || '',
                garageLocationId: GarageLocationStore.data.userGarage || '',
                unitId: this.unitId || ''
            };
        }
    },
    methods: {
        async getDateBasedTask(id) {
            try {
                this.$wait.start('loading date based task');
                this.$wait.start('loading data');
                const response = await this.$api.get(`date-based-tasks/${id}`);
                this.$bus.$emit(Event.DateBasedTaskUpdated, response.data);
            } catch (error) {
                this.$toast.error('There was an error getting date-based task');
            } finally {
                this.$wait.end('loading date based task');
                this.$wait.end('loading data');
            }
        },
        async getDateBasedTasks() {
            try {
                this.$wait.start('loading date based tasks');
                const response = await this.$api.get(`date-based-tasks${this.querystring}`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting date-based tasks');
                return [];
            } finally {
                this.$wait.end('loading date based tasks');
            }
        },
        async getDateBasedTasksForUnit() {
            try {
                this.$wait.start('loading data');
                const response = await this.$api.get(`date-based-tasks${this.querystring}`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting date-based tasks');
                return [];
            } finally {
                this.$wait.end('loading data');
            }
        },
        async getDateBasedTaskHistoryForUnit(unitId) {
            try {
                this.$wait.start('loading data');
                const response = await this.$api.get(`units/${unitId}/date-based-task-history`);
                return response.data;
            } catch (error) {
                this.$toast.error('There was an error getting date-based task history');
                return [];
            } finally {
                this.$wait.end('loading data');
            }
        },
        async getDateBasedTaskDescriptionLookups() {
            try {
                this.$wait.start('loading date based task description lookups');
                this.$wait.start('loading data');
                const response = await this.$api.get('date-based-task-description-lookups');
                return response.data.sort(this.compareDescription);
            } catch (error) {
                this.$toast.error('There was an error getting date-based task description lookups');
                return [];
            } finally {
                this.$wait.end('loading date based task description lookups');
                this.$wait.end('loading data');
            }
        },
        async addDateBasedTask(id, add) {
            try {
                this.loading = true;
                await this.$api.put(`date-based-tasks/${id}`, add);
                this.$bus.$emit(Event.DateBasedTaskUpdated, { ...add, id });
                this.$toast.success(`'${add.description}' added`);
            } catch (err) {
                this.$toast.error(`Could not add '${add.description}'`);
            } finally {
                this.loading = false;
            }
        },
        async updateDateBasedTask(id, update) {
            try {
                this.loading = true;
                await this.$api.put(`date-based-tasks/${id}`, update);
                this.$bus.$emit(Event.DateBasedTaskUpdated, update);
                this.$toast.success(`'${update.description}' updated`);
            } catch (err) {
                this.$toast.error(`Could not update '${update.description}'`);
                this.$toast.error(err);
            } finally {
                this.loading = false;
            }
        },
        async completeDateBasedTask(command) {
            try {
                this.$wait.start('completing date-based task');
                this.$wait.start('loading date-based task data');
                const response = await this.$api.post(`date-based-tasks/complete`, command);
                this.$bus.$emit(Event.DateBasedTaskCompleted, response.data);
            } catch (error) {
                this.$toast.error('There was an error completing the date-based task');
            } finally {
                this.$wait.end('completing date-based task');
                this.$wait.end('loading date-based task data');
            }
        },
        async deleteDateBasedTask(dateBasedTaskId) {
            try {
                const response = await this.$api.delete(`date-based-tasks/${dateBasedTaskId}`);
                this.$bus.$emit(Event.DateBasedTaskDeleted, response.data);
            } catch (err) {
                this.$toast.error(`Could not delete date-based task`);
            } finally {
                this.$toast.success(`Date-based task deleted`);
            }
        },
        compareDescription(a, b) {
            return a.description.localeCompare(b.description);
        }
    }
};
</script>
